import {
  BrokenDatabase,
  Database,
  DatabaseField,
  EntryCreateOptions,
  EntryWithContext,
} from '@databases/types/database';
import { DatabaseView } from '@databases/types/database/view';
import { isNonBrokenDatabase } from '@databases/utils/database/utils';

import { isCreate } from '../entryPicker/DatabaseEntryPicker';

import { handleCreateEntry } from './createEntry';

enum MacroType {
  DATABASE = 'DATABASE',
  ENTRY = 'ENTRY',
  VALUE = 'VALUE',
}

export const getEmbedUrl = async (
  selectedDatabase: Database | BrokenDatabase,
  selectedEntry: EntryWithContext | EntryCreateOptions | undefined,
  selectedField: DatabaseField | undefined,
  dispatch: any,
  store: any,
  view: DatabaseView | null,
  analyticsClient: any,
  spaceKey: string,
  baseUrl: string
) => {
  if (isNonBrokenDatabase(selectedDatabase)) {
    let queryString = '';
    let macroType: MacroType = MacroType.DATABASE;
    let isNew = false;

    if (selectedEntry) {
      if (isCreate(selectedEntry)) {
        const createdEntryId = await handleCreateEntry(selectedDatabase, dispatch, store);
        if (createdEntryId) {
          queryString = `?entryId=${createdEntryId}`;
          isNew = true;
        }
      } else {
        queryString = `?entryId=${selectedEntry.entry.id}`;
      }
      macroType = MacroType.ENTRY;
    }

    if (selectedField) {
      queryString += `&fieldId=${selectedField.id}`;
      macroType = MacroType.VALUE;
    }

    if (!selectedEntry && !selectedField && view) {
      queryString += `?savedViewId=${view.id}`;
    }

    await analyticsClient.sendMacroCreatedEvent({
      macroType: macroType,
      contentId: selectedDatabase.contentId,
      isNew: isNew,
      source: 'databaseReferenceModal',
    });

    const message: { finalDatabaseUrl: string } = {
      finalDatabaseUrl: `${baseUrl}/spaces/${spaceKey}/database/${selectedDatabase.contentId}${queryString}`,
    };

    return message;
  }
};
